(() => {
  const config = document.getElementById('curated-booking-badge-config');
  if (!config) return;
  let sdkPromise;
  let observedTeaser;
  let positionFrame;
  const resizeObserver = new ResizeObserver(() => schedulePosition());
  const teaserObserver = new MutationObserver(() => schedulePosition());
  const getSdk = () => {
    if (sdkPromise) return sdkPromise;
    if (!document.querySelector('link[href="https://assets.calendly.com/assets/external/widget.css"]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://assets.calendly.com/assets/external/widget.css';
      document.head.appendChild(css);
    }
    if (window.Calendly) return Promise.resolve(window.Calendly);
    sdkPromise = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      const isNew = !script;
      if (isNew) {
        script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
      }
      script.addEventListener('load', () => resolve(window.Calendly), { once: true });
      script.addEventListener('error', reject, { once: true });
      if (isNew) document.head.appendChild(script);
    });
    return sdkPromise;
  };
  const enhancePopup = trigger => {
    const overlay = document.querySelector('.calendly-overlay');
    const close = overlay?.querySelector('.calendly-popup-close');
    if (!overlay || !close) return;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', trigger.getAttribute('aria-label') || trigger.textContent.trim());
    close.setAttribute('role', 'button');
    close.setAttribute('tabindex', '0');
    close.setAttribute('aria-label', config.dataset.closeLabel);
    close.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        close.click();
      }
    });
    const onEscape = event => {
      if (event.key === 'Escape') close.click();
    };
    document.addEventListener('keydown', onEscape);
    overlay.addEventListener('click', event => {
      if (event.target === close || event.target.classList.contains('calendly-close-overlay')) {
        document.removeEventListener('keydown', onEscape);
        trigger.focus();
      }
    });
    close.focus();
  };
  const setVariable = (element, name, value) => {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  };
  const positionBadge = () => {
    positionFrame = undefined;
    const badge = document.querySelector('.curated-calendly-badge');
    if (!badge) return;
    if (window.innerWidth < 768) {
      const backToTop = document.querySelector('#t4s-backToTop');
      if (backToTop) {
        const anchorStyle = getComputedStyle(backToTop);
        const inset = parseFloat(anchorStyle.right);
        const bottom = parseFloat(anchorStyle.bottom);
        setVariable(document.documentElement, '--curated-mobile-floating-inset', `${Number.isFinite(inset) ? inset : 15}px`);
        setVariable(document.documentElement, '--curated-mobile-floating-bottom', `${Number.isFinite(bottom) ? bottom : 25}px`);
      }
    }
    const candidates = [...document.querySelectorAll('[class*="kl-teaser-"]')];
    const isVisibleButton = button => {
      if (!button || !button.textContent.trim()) return false;
      const rect = button.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || rect.top < 0 || rect.left < 0 || rect.bottom > window.innerHeight + 1 || rect.right > window.innerWidth + 1) return false;
      for (let element = button; element; element = element.parentElement) {
        const style = getComputedStyle(element);
        if (element.hidden || element.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility !== 'visible' || style.contentVisibility === 'hidden' || Number(style.opacity) < 0.99) return false;
      }
      const hit = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
      return !!hit && button.contains(hit);
    };
    const teaser = candidates.find(element => isVisibleButton(element.querySelector('[role="button"]')));
    const watchTeaser = teaser || candidates[0];
    if (watchTeaser !== observedTeaser) {
      resizeObserver.disconnect();
      teaserObserver.disconnect();
      observedTeaser = watchTeaser;
      if (watchTeaser) {
        resizeObserver.observe(watchTeaser);
        const button = watchTeaser.querySelector('[role="button"]');
        if (button) resizeObserver.observe(button);
        teaserObserver.observe(watchTeaser, { attributes: true, subtree: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
        for (let parent = watchTeaser.parentElement; parent; parent = parent.parentElement) {
          teaserObserver.observe(parent, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
        }
      }
    }
    const promoVisible = teaser ? 'true' : 'false';
    if (badge.dataset.promoVisible !== promoVisible) badge.dataset.promoVisible = promoVisible;
    if (teaser) badge.style.removeProperty('display');
    else if (badge.style.display !== 'none') badge.style.display = 'none';
    if (watchTeaser?.getAnimations({ subtree: true }).some(animation => animation.playState === 'running')) schedulePosition();
    if (teaser) {
      if (!teaser.hasAttribute('data-curated-promo-teaser')) teaser.setAttribute('data-curated-promo-teaser', '');
      const promoText = teaser.querySelector('[role="button"] p');
      if (promoText && !promoText.querySelector('.curated-promo-tag')) {
        const tag = document.createElement('i');
        tag.className = 'las la-tag curated-promo-tag';
        tag.setAttribute('aria-hidden', 'true');
        promoText.prepend(tag);
      }
      const rect = teaser.querySelector('[role="button"]').getBoundingClientRect();
      const text = teaser.querySelector('strong') || teaser.querySelector('[role="button"]') || teaser;
      const type = getComputedStyle(text);
      if (window.innerWidth < 768) {
        const diameter = rect.height;
        setVariable(document.documentElement, '--curated-mobile-floating-size', `${diameter}px`);
        setVariable(badge, '--curated-badge-left', `${rect.right + 15}px`);
        setVariable(badge, '--curated-badge-width', `${diameter}px`);
        setVariable(badge, '--curated-badge-height', `${diameter}px`);
        setVariable(badge, '--curated-badge-bottom', 'var(--curated-mobile-floating-bottom, 25px)');
      } else {
        setVariable(badge, '--curated-badge-left', `${Math.max(0, rect.left)}px`);
        setVariable(badge, '--curated-badge-width', `${Math.min(rect.width, window.innerWidth - rect.left - 12)}px`);
        setVariable(badge, '--curated-badge-bottom', `${Math.max(0, window.innerHeight - rect.top) + 10}px`);
        setVariable(badge, '--curated-badge-height', `${rect.height}px`);
      }
      setVariable(badge, '--curated-badge-font-size', type.fontSize);
      setVariable(badge, '--curated-badge-font-family', type.fontFamily);
      setVariable(badge, '--curated-badge-font-weight', type.fontWeight);
      setVariable(badge, '--curated-badge-line-height', type.lineHeight);
      setVariable(badge, '--curated-badge-letter-spacing', type.letterSpacing);
    } else {
      setVariable(badge, '--curated-badge-left', window.innerWidth < 768 ? '12px' : '40px');
      setVariable(badge, '--curated-badge-bottom', '25px');
    }
  };
  const schedulePosition = () => {
    if (!positionFrame) positionFrame = requestAnimationFrame(positionBadge);
  };
  const initializeBadge = sdk => {
    if (config.dataset.showBadge !== 'true' || document.querySelector('.curated-calendly-badge')) return;
    sdk.initBadgeWidget({ url: config.dataset.url, text: config.dataset.label, color: config.dataset.color, textColor: config.dataset.textColor, branding: false });
    const badge = document.querySelector('.calendly-badge-widget');
    if (!badge) return;
    badge.style.display = 'none';
    badge.classList.add('curated-calendly-badge');
    badge.dataset.mobile = config.dataset.mobile;
    badge.style.setProperty('--curated-badge-hover-color', config.dataset.hoverColor || '#855644');
    const trigger = badge.querySelector('.calendly-badge-content');
    const tape = document.createElement('i');
    tape.className = 'las la-tape curated-fitting-tape';
    tape.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.className = 'curated-fitting-label';
    label.textContent = config.dataset.label;
    trigger.replaceChildren(tape, label);
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-label', config.dataset.label);
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.addEventListener('click', () => queueMicrotask(() => enhancePopup(trigger)));
    trigger.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        trigger.click();
      }
    });
    positionBadge();
    new MutationObserver(schedulePosition).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('transitionrun', schedulePosition, true);
    document.addEventListener('animationstart', schedulePosition, true);
    document.addEventListener('transitionend', schedulePosition, true);
    document.addEventListener('animationend', schedulePosition, true);
    window.addEventListener('scroll', schedulePosition, { passive: true });
    window.addEventListener('resize', schedulePosition, { passive: true });
    window.visualViewport?.addEventListener('resize', schedulePosition, { passive: true });
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-curated-calendly]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    getSdk().then(sdk => {
      sdk.initPopupWidget({ url: trigger.href });
      enhancePopup(trigger);
    }).catch(() => window.location.assign(trigger.href));
  });
  const start = () => getSdk().then(initializeBadge).catch(() => {});
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
